module.exports = __webpack_public_path__ + "static/media/staff-token.425cfd89.svg";